import logErrors from '@nykaa/nes-logger/logErrors';
import { ApiHelper } from 'api';
import { HttpMethods } from 'constants/requestHeaders';
import { getUrl, ROUTES } from 'shared/api/urls';


const ERROR_SENDING_DEVICE_INFO = 'Error sending device info';
export const postDeviceIdentity = async (
  deviceInfoString: string,
) => {
  const requestData = { deviceInfo: deviceInfoString };
  const endPointForDeviceTracking = getUrl(ROUTES.DEVICE_TRACKING_SERVICE);

  try {
    await ApiHelper(
      endPointForDeviceTracking,
      HttpMethods.POST,
      requestData,
    );
  } catch (err) {
    logErrors(err, `${ERROR_SENDING_DEVICE_INFO} :url=${endPointForDeviceTracking}`);
  }
};
